/**
 * @file WholeSiteList.tsx
 * @description Раздел «Весь сайт» в навигаторе конструктора (phase19.16
 * Р1-6а; uiux-builder-shell.md §2.1, §2.3, §9): Оформление, Дизайны, Меню,
 * Настройки сайта, SEO, Лента блога, История. У раздела — пояснение
 * строкой, «●N» неопубликованных изменений, «✕» у настроек без сведений о
 * продавце (публиковать нельзя), замок — меняет другой сотрудник.
 * Подпись: «меняется на всех страницах после публикации вида».
 */

import { Lock } from "lucide-react";

import { useSiteView } from "../../site-view/site-view-context";
import { useBuilder } from "../builder-context";
import { BUILDER_PANEL_META, WHOLE_SITE_ORDER } from "../../../lib/site-builder/panels";
import { cn } from "@/lib/utils";

export function WholeSiteList({ showHints = false }: { showHints?: boolean }) {
  const b = useBuilder();
  const view = useSiteView();
  const changes = view.changes;
  const sellerBlocked = changes?.checks.some((c) => c.code === "site_view_seller_incomplete") ?? false;

  return (
    <nav aria-label="Весь сайт" className="flex flex-col gap-0.5">
      {WHOLE_SITE_ORDER.map((key) => {
        const meta = BUILDER_PANEL_META[key];
        const Icon = meta.icon;
        const count = key === "designs" || !meta.part ? 0 : (changes?.changedParts.find((p) => p.part === meta.part)?.count ?? 0);
        const locked = meta.part !== null && key !== "designs" && !view.editableParts.includes(meta.part);
        const active = b.selection.panel === key;
        return (
          <button
            key={key}
            type="button"
            onClick={() => void b.select({ panel: key, sub: null })}
            aria-current={active ? "true" : undefined}
            className={cn(
              "flex w-full items-center gap-3 rounded-md px-3 text-left outline-none focus-visible:ring-2 focus-visible:ring-ring",
              showHints ? "min-h-16 py-2" : "min-h-12",
              active ? "bg-primary/10" : "hover:bg-surface-low",
            )}
          >
            <Icon aria-hidden className="size-4 shrink-0 text-on-surface-variant" />
            <span className="flex min-w-0 flex-1 flex-col">
              <span className="type-body truncate font-medium text-on-surface">{meta.label}</span>
              {showHints ? <span className="type-caption truncate text-on-surface-variant">{meta.hint}</span> : null}
            </span>
            {count > 0 ? (
              <span className="type-caption shrink-0 text-warning" title="Не опубликовано">
                ● {count}
              </span>
            ) : null}
            {key === "settings" && sellerBlocked ? (
              <span className="type-caption shrink-0 text-destructive" title="Не заполнены сведения о продавце">
                ✕
              </span>
            ) : null}
            {locked ? <Lock aria-label="Меняет другой сотрудник" className="size-4 shrink-0 text-on-surface-variant" /> : null}
          </button>
        );
      })}
      <p className="type-caption px-3 pt-1 text-on-surface-variant">Меняется на всех страницах после публикации вида сайта.</p>
    </nav>
  );
}
